// extracted by mini-css-extract-plugin
export default {"textarea":"TextAreaInput__textarea__y2MAr"};